module.exports = __webpack_public_path__ + "img/succ.ec45d255.png";